<template>
  <q-page class="login align-items-center justify-center">
    <!-- <div class="col-1 col-sm-2 col-md-7"></div> -->
    <div style="display: flex; flex-direction: column; align-items: center">
      <img
        src="~@/assets/logo-light.svg"
        alt="Casimba Logo"
        style="width: 200px; margin: 20px auto"
      />

      <div
        class="flex shadow-3 q-px-md q-py-lg"
        style="min-width: 340px; background-color: white; border-radius: 0.5em"
      >
        <q-card flat class="flex column content-card" style="width: 100%">
          <q-card-section class="login__header flex text-h6 q-pl-lg q-py-none">
            Client Portal
          </q-card-section>
          <q-card-section class="q-px-lg">
            <TheLoginForm />
          </q-card-section>
        </q-card>
      </div>
    </div>
    <!-- <div class="col-*"></div> -->
  </q-page>
</template>

<script>
import TheLoginForm from "@/components/TheLoginForm.vue";
export default {
  name: "TheLogin",
  components: {
    TheLoginForm,
  },
  methods: {
    reloadForm() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
.login {
  background-color: #fff;
  background-image: url("~@/assets/login-bg.svg");
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: contain;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 380px;
}

// Dark Mode
.body {
  &--dark {
    .login {
      background-image: url("~@/assets/login-background-dark.svg");
      &__logo {
        background-image: url("~@/assets/logo-dark.svg");
      }
    }
  }
}
</style>
